import React, { useEffect, useState } from 'react';
import { axiosInstance } from '../App';

// Profile photos are served behind sign-in, which a plain <img> cannot send,
// so the photo is fetched with the session and shown from a local object URL.
const AuthImage = ({ src, alt = '', className, fallback = null }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    setUrl(null);
    if (typeof src !== 'string' || !/^\/api\/uploads\/photos\/[A-Za-z0-9_.-]+$/.test(src)) return undefined;
    let objectUrl = null;
    let cancelled = false;
    const path = src.replace(/^\/api/, '');
    axiosInstance.get(path, { responseType: 'blob' })
      .then(({ data }) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setUrl(objectUrl);
      })
      .catch(() => { if (!cancelled) setUrl(null); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);

  return url ? <img src={url} alt={alt} className={className} /> : fallback;
};

export default AuthImage;
